import React from 'react';
import { motion } from 'framer-motion';

const PHASES_IMG = "https://media.base44.com/images/public/user_6925d9d627c76e39d999f15c/0603b0a6d_1000147963.jpg";

const phases = [
  {
    number: "01",
    title: "Foundation & Trust",
    description: "Building relationships, establishing trust within the community, and laying the groundwork for sustainable development."
  },
  {
    number: "02",
    title: "Infrastructure Pilot",
    description: "Launching pilot programs, testing community-driven solutions, and developing the infrastructure needed for growth."
  },
  {
    number: "03",
    title: "Campus Development",
    description: "Constructing the integrated development and training campus — a hub for education, wellness, and economic opportunity."
  },
  {
    number: "04",
    title: "Regional Excellence",
    description: "Scaling our proven model to impact surrounding regions, creating a network of empowered, self-sustaining communities."
  }
];

export default function DevelopmentPhases() {
  return (
    <section id="phases" className="py-24 sm:py-32 bg-accent text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-secondary font-medium tracking-[0.2em] uppercase text-sm mb-4">Our Roadmap</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold">
            Integrated Development &amp;{' '}
            <span className="text-secondary italic">Training Campus</span>
          </h2>
          <p className="text-white/70 mt-4 max-w-2xl mx-auto text-lg">
            Our phased approach ensures every step builds upon the last, creating lasting impact.
          </p>
        </motion.div>

        {/* Phases image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 rounded-2xl overflow-hidden shadow-2xl"
        >
          <img
            src={PHASES_IMG}
            alt="Rose of Jericho Community Development - Integrated Development & Training Campus Rollout Phases"
            className="w-full h-auto"
          />
        </motion.div>

        {/* Phase cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {phases.map((phase, i) => (
            <motion.div
              key={phase.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors"
            >
              <span className="text-secondary text-4xl font-heading font-bold">{phase.number}</span>
              <h3 className="text-lg font-heading font-semibold mt-3 mb-2">{phase.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{phase.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}